export default __webpack_public_path__ + "loginBg.7d9a0911.png";